const DEFAULT_ITEMS_PER_PAGE = 5;
const MAX_ITEMS_PER_PAGE = 5000;
const ITEMS_PER_PAGE_PRESETS = [5, 100, 300, 500];

export default {
    data() {
        return {
            itemsPerPageInput: DEFAULT_ITEMS_PER_PAGE,
            itemsPerPageMax: MAX_ITEMS_PER_PAGE
        };
    },
    computed: {
        datatableFooter() {
            return {
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                'items-per-page-options': [...ITEMS_PER_PAGE_PRESETS, -1],
                ...(this.footer || {}),
                'disable-items-per-page': true
            };
        },

        itemsPerPageLabel() {
            return this.$vuetify.lang.t('$vuetify.dataTable.itemsPerPageText');
        },

        itemsPerPageAllText() {
            return this.$vuetify.lang.t('$vuetify.dataFooter.itemsPerPageAll');
        },

        itemsPerPageChoices() {
            return [
                ...ITEMS_PER_PAGE_PRESETS.map((n) => ({
                    text: String(n),
                    value: n
                })),
                {
                    text: this.itemsPerPageAllText,
                    value: -1
                }
            ];
        }
    },
    methods: {
        currentItemsPerPage() {
            const current = this.datatableOptions && this.datatableOptions.itemsPerPage;
            return current === -1 || (Number.isFinite(current) && current > 0) ?
                current :
                DEFAULT_ITEMS_PER_PAGE;
        },

        normalizeItemsPerPage(raw) {
            const fallback = this.currentItemsPerPage();
            if (raw === null || raw === undefined || raw === '') {
                return fallback;
            }

            if (typeof raw === 'object') {
                if (raw && raw.value !== undefined) {
                    raw = raw.value;
                } else {
                    return fallback;
                }
            }

            const asString = String(raw).trim();
            if (raw === -1 || asString === '-1' || asString === this.itemsPerPageAllText) {
                return -1;
            }

            if (!/^\d+$/.test(asString)) {
                return fallback;
            }

            const n = parseInt(asString, 10);
            if (!Number.isFinite(n) || n < 1) {
                return fallback;
            }

            return n > this.itemsPerPageMax ? this.itemsPerPageMax : n;
        },

        applyItemsPerPage(raw) {
            const next = this.normalizeItemsPerPage(raw);
            this.itemsPerPageInput = next;
            if (!this.datatableOptions) {
                return next;
            }
            if (this.datatableOptions.itemsPerPage !== next) {
                this.datatableOptions.itemsPerPage = next;
                this.datatableOptions.page = 1;
            }
            return next;
        },

        commitItemsPerPageInput() {
            this.applyItemsPerPage(this.itemsPerPageInput);
        }
    }
};